import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ROUTES } from '../../utils/constants';
import { isAdmin } from '../../utils/roleUtils';
import logo from '../../assets/logo.svg';
import './Header.css';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate(ROUTES.LOGIN);
  };

  const handleProfileClick = () => {
    navigate(ROUTES.PROFILE);
  };

  const handleLogoClick = () => {
    if (user) {
      // Admins go to admin panel, others go to dashboard
      if (isAdmin(user)) {
        navigate('/admin/dashboard');
      } else {
        navigate(ROUTES.DASHBOARD);
      }
    }
  };

  const isProfilePage = location.pathname === ROUTES.PROFILE;

  return (
    <header className="header">
      <div className="header__container">
        <div 
          className="header__brand"
          onClick={handleLogoClick}
          style={{ cursor: user ? 'pointer' : 'default' }}
        >
          <img src={logo} alt="Sage Locum Logo" className="header__logo" />
        </div>
        
        {user && (
          <div className="header__actions">
            <button 
              className={`header__profile ${isProfilePage ? 'header__profile--active' : ''}`}
              onClick={handleProfileClick}
              title="Profile"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="header__action-label">Profile</span>
            </button>
            
            <button 
              className="header__logout"
              onClick={handleLogout}
              title="Logout"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="16,17 21,12 16,7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="header__action-label">Logout</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
